import styled from "styled-components";

import { Maybe } from "@graphql-types";
import { AbsoluteWrapper, Container } from "@util/standard";
import { colors, fontSizes, mediaQuery } from "@util/constants";

export const PanelWrapper = styled.div`
  position: relative;
  height: 100vh;
  width: 100%;
  scroll-snap-align: center;
  background: ${colors.charcoal};
`;

export const TextWrapper = styled(AbsoluteWrapper)`
  top: 50%;
  left: 6%;
  transform: translateY(-50%);
  color: ${colors.white};
  h2 {
    font-size: ${fontSizes.h1.default}px;
  }

  ${mediaQuery.largeDown} {
    top: 45px;
    left: 35px;
    transform: translate(0px, 0px);
  }
  ${mediaQuery.smallDown} {
    h1 {
      font-weight: 100;
      width: 70%;
      padding-left: 10px;
    }
    h2 {
      font-size: ${fontSizes.h1.mobile}px;
      width: 70%;
      padding-left: 10px;
      font-weight: 100;
    }
    a {
      span {
        padding: 10px;
      }
    }
  }
  ${mediaQuery.smallDown} {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 0 15px;
    display: flex;
    flex-direction: column;

    justify-content: center;
  }
`;

export const ContainerWrapper = styled(Container)`
  // height: 100vh;
`;

export const SwiperContainer = styled(Container)<{
  displayDots?: Maybe<boolean> | undefined;
}>`
  .swiper-brand-or-range {
    width: 100%;
    height: 100vh;
    z-index: 0;
    .swiper-pagination-vertical {
      ${({ displayDots }) => (displayDots ? `visibility: visible;` : `visibility: hidden;`)}
      right: 6%;
    }
    .swiper-pagination-bullet-active,
    .swiper-pagination-bullet {
      border-radius: 0px;

      width: 5px;
      height: 19px;

      background: ${colors.white};

      opacity: 0.5;
    }
    .swiper-pagination-bullet-active {
      background: ${colors.white};
      opacity: 1;
    }
  }
`;
